/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './growth-legend.reducer';

export const GrowthLegendDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const growthLegendEntity = useAppSelector(state => state.growthLegend.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="growthLegendDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.growthLegend.detail.title">GrowthLegend</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.growthLegend.id">Id</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.id}</dd>
          <dt>
            <span id="reportType">
              <Translate contentKey="tinyMedicRestApp.growthLegend.reportType">Report Type</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.reportType}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.growthLegend.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.gender}</dd>
          <dt>
            <span id="chartType">
              <Translate contentKey="tinyMedicRestApp.growthLegend.chartType">Chart Type</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.chartType}</dd>
          <dt>
            <span id="ageFrom">
              <Translate contentKey="tinyMedicRestApp.growthLegend.ageFrom">Age From</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.ageFrom}</dd>
          <dt>
            <span id="ageTo">
              <Translate contentKey="tinyMedicRestApp.growthLegend.ageTo">Age To</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.ageTo}</dd>
          <dt>
            <span id="ageUnit">
              <Translate contentKey="tinyMedicRestApp.growthLegend.ageUnit">Age Unit</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.ageUnit}</dd>
          <dt>
            <span id="lambda">
              <Translate contentKey="tinyMedicRestApp.growthLegend.lambda">Lambda</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.lambda}</dd>
          <dt>
            <span id="mean">
              <Translate contentKey="tinyMedicRestApp.growthLegend.mean">Mean</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.mean}</dd>
          <dt>
            <span id="sigma">
              <Translate contentKey="tinyMedicRestApp.growthLegend.sigma">Sigma</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.sigma}</dd>
          <dt>
            <span id="delta">
              <Translate contentKey="tinyMedicRestApp.growthLegend.delta">Delta</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.delta}</dd>
          <dt>
            <span id="p01">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p01">P 01</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p01}</dd>
          <dt>
            <span id="p1">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p1">P 1</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p1}</dd>
          <dt>
            <span id="p3">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p3">P 3</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p3}</dd>
          <dt>
            <span id="p5">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p5">P 5</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p5}</dd>
          <dt>
            <span id="p10">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p10">P 10</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p10}</dd>
          <dt>
            <span id="p15">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p15">P 15</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p15}</dd>
          <dt>
            <span id="p25">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p25">P 25</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p25}</dd>
          <dt>
            <span id="p50">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p50">P 50</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p50}</dd>
          <dt>
            <span id="p75">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p75">P 75</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p75}</dd>
          <dt>
            <span id="p85">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p85">P 85</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p85}</dd>
          <dt>
            <span id="p90">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p90">P 90</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p90}</dd>
          <dt>
            <span id="p95">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p95">P 95</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p95}</dd>
          <dt>
            <span id="p97">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p97">P 97</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p97}</dd>
          <dt>
            <span id="p99">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p99">P 99</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p99}</dd>
          <dt>
            <span id="p999">
              <Translate contentKey="tinyMedicRestApp.growthLegend.p999">P 999</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.p999}</dd>
          <dt>
            <span id="SD4neg">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD4neg">SD 4 Neg</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD4neg}</dd>
          <dt>
            <span id="SD3neg">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD3neg">SD 3 Neg</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD3neg}</dd>
          <dt>
            <span id="SD2neg">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD2neg">SD 2 Neg</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD2neg}</dd>
          <dt>
            <span id="SD1neg">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD1neg">SD 1 Neg</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD1neg}</dd>
          <dt>
            <span id="SD0">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD0">SD 0</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD0}</dd>
          <dt>
            <span id="SD1">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD1">SD 1</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD1}</dd>
          <dt>
            <span id="SD2">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD2">SD 2</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD2}</dd>
          <dt>
            <span id="SD3">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD3">SD 3</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD3}</dd>
          <dt>
            <span id="SD4">
              <Translate contentKey="tinyMedicRestApp.growthLegend.SD4">SD 4</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.SD4}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.growthLegend.active">Active</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.growthLegend.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.growthLegend.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.growthLegend.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.growthLegend.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.cursor}</dd>
          <dt>
            <span id="publishedYear">
              <Translate contentKey="tinyMedicRestApp.growthLegend.publishedYear">Published Year</Translate>
            </span>
          </dt>
          <dd>{growthLegendEntity.publishedYear}</dd>
        </dl>
        <Button tag={Link} to="/growth-legend" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/growth-legend/${growthLegendEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GrowthLegendDetail;
